export const crudSideBar = {
  create: 'create',
  view: 'view',
  edit: 'edit',
  delete: 'delete',
  addContact: 'addContact',
  addSalesRep: 'addSalesRep',
}

export const cancelableCrudSideBar = {
  cancel: 'cancel',
  reject: 'reject',
}
